import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    dialogRoot: {
        padding: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(8)
        }
    },
    dialogTitleRoot: {
        color: theme.palette.common.white,
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(8, 0, 4)
        }
    },
    dialogContentRoot: {
        overflowWrap: 'break-word',
        paddingTop: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2, 2, 4),
            marginBottom: theme.spacing(4)
        }
    },
    dialogContentTextRoot: {
        marginBottom: theme.spacing(4)
    },
    dialogActionsRoot: {
        [theme.breakpoints.down('xs')]: {
            padding: 0
        }
    },
    closeIconRoot: {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: `${theme.spacing(2)}px !important`
    }
}));

export default useStyles;
